import { useState } from 'react';

import { Box, CircularProgress, IconButton, TextField } from '@mui/material';
import Check from '@mui/icons-material/Check';

import { BaseEditControlProps, TextDataTypes } from '../Table.types';

export const TextEditControl = ({
  initialValue,
  onSubmitChange,
  type = 'text',
  isSaving,
  isInvalid,
  ...controlProps
}: BaseEditControlProps<TextDataTypes>) => {
  const [value, setValue] = useState(initialValue);

  return (
    <Box display="flex" width="100%" alignItems="center" justifyContent="space-between">
      <TextField
        {...controlProps}
        error={isInvalid}
        type={type}
        fullWidth
        value={value}
        onChange={evt => setValue(evt.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter' && value !== initialValue && !isSaving) {
            onSubmitChange(value);
          }
          controlProps?.onKeyDown?.(e);
        }}
      />

      <IconButton
        disableFocusRipple={true}
        disableRipple
        disabled={isSaving || value === initialValue}
        onClick={() => onSubmitChange(value)}
        size="small"
      >
        {isSaving ? (
          <CircularProgress color="primary" variant="indeterminate" size={16} />
        ) : (
          <Check fontSize="small" />
        )}
      </IconButton>
    </Box>
  );
};
